<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm()" (cancel)="cancel()">
  <div style="min-width: 600px">
    <mat-expansion-panel class="expansion-panel-margin" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h3>{{ 'cropFieldDetails' | translate }}</h3>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        <div class="flex--row spacing--padding-vertical">
          <div class="spacing--padding-horizontal">
            <div class="text--label">{{ 'name' | translate }}</div>
            <div class="text--bold">{{ cropField.name }}</div>
          </div>
          <div class="spacing--padding-horizontal">
            <div class="text--label">{{ 'hectares' | translate }}</div>
            <div class="text--bold">{{ cropField.areaInHectares | number: '1.2-2' }}</div>
          </div>
          <div class="spacing--padding-horizontal">
            <div class="text--label">{{ 'province' | translate }}</div>
            <div class="text--bold">{{ cropField.province }}</div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="flex--row spacing--padding-vertical">
          <div class="spacing--padding-horizontal">
            <div class="text--label">{{ 'startDate' | translate }}</div>
            <div class="text--bold">{{ cropField.startDate | date: 'shortDate' : undefined : locale() }}</div>
          </div>
          <div class="spacing--padding-horizontal">
            <div class="text--label">{{ 'endDate' | translate }}</div>
            <div class="text--bold">{{ cropField.endDate | date: 'shortDate' : undefined : locale() }}</div>
          </div>
          <div class="spacing--padding-horizontal">
            <div class="text--label"></div>
            <div class="text--bold"></div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="flex--row spacing--padding-vertical">
          <div class="spacing--padding-horizontal">
            <div class="text--label">{{ 'soilType' | translate }}</div>
            <div class="text--bold">{{ soilType() }}</div>
          </div>
          <div class="spacing--padding-horizontal">
            <div class="text--label">{{ 'crop' | translate }}</div>
            <div class="text--bold">{{ crop }}</div>
          </div>
          @if (cropVariety()) {
            <div class="spacing--padding-horizontal">
              <div class="text--label">{{ 'cropVariety' | translate }}</div>
              <div class="text--bold">{{ cropVariety() }}</div>
            </div>
          }
        </div>
        <mat-divider></mat-divider>
        <div class="flex--row spacing--padding-vertical">
          <div class="spacing--padding-horizontal">
            <div class="text--label">{{ 'manualCrops.groundwaterPreservation' | translate }}</div>
            <div class="text--bold">
              @if (cropField.isGroundWaterPreservation) {
                <mat-icon class="text-color--primary-500">check_circle</mat-icon>
              } @else {
                <mat-icon class="text-color--gray3">horizontal_rule</mat-icon>
              }
            </div>
          </div>
          <div class="spacing--padding-horizontal">
            <div class="text--label">{{ 'manualCrops.planetProof' | translate }}</div>
            <div class="text--bold">
              @if (cropField.isPlanetProof) {
                <mat-icon class="text-color--primary-500">check_circle</mat-icon>
              } @else {
                <mat-icon class="text-color--gray3">horizontal_rule</mat-icon>
              }
            </div>
          </div>
          <div class="spacing--padding-horizontal">
            <div class="text--label">{{ 'manualCrops.organic' | translate }}</div>
            <div class="text--bold">
              @if (cropField.isSkal) {
                <mat-icon class="text-color--primary-500">check_circle</mat-icon>
              } @else {
                <mat-icon class="text-color--gray3">horizontal_rule</mat-icon>
              }
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel class="expansion-panel-margin" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h3>{{ 'GBMAdvice' | translate }}</h3>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-cropfield-treatments [treatments]="gbmTreatments"> </app-cropfield-treatments>
    </mat-expansion-panel>

    @if (showFertilizationAdvice$ | async) {
      <mat-expansion-panel class="expansion-panel-margin" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h3>{{ 'fertilizationAdvice' | translate }}</h3>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-cropfield-treatments [treatments]="fertilizationTreatments"> </app-cropfield-treatments>
      </mat-expansion-panel>
    }
  </div>
</agr-form-dialog>
